/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      // console.log('Container ———————— ↓');
      // console.log(container);
      // console.log('Variant —————————— ↓');
      // console.log(variant);
      // ... update some element on the page
      const variantMetafieldId = `variant_metafield_${variant.id}`;
          const metafieldElement = document.getElementById(variantMetafieldId);
          if (metafieldElement) {
            const variantDescription = metafieldElement.innerHTML;
            const VariantDescription = document.querySelector('.accordion-content__inner');
            VariantDescription.innerHTML = variantDescription;
          } else {
            console.error(`Metafeld für Variante ${variantMetafieldId} nicht gefunden.`);
          }
      // const variantSlideTextId = `slide_text_${variant.id}`;
      //     const slidetextElement = document.getElementById(variantSlideTextId);
      //     if (slidetextElement) {
      //       const variantSlideText = slidetextElement.innerHTML;
      //       const VariantSlideText = document.querySelector('.brick__block__text__text');
      //       VariantSlideText.innerHTML = variantSlideText;
      //     } else {
      //       console.error(`Metafeld für Variante ${variantSlideTextId} nicht gefunden.`);
      //     }
      // const variantId = variant.id;
      //       const imgElements = document.querySelectorAll('[data-variant-picture]');
      //       imgElements.forEach(imgElement => {
      //           const pictureNumber = imgElement.getAttribute('data-variant-picture'); // Hier wird die Nummer des Bild-Metafelds extrahiert (z.B. 'one', 'two', usw.)
      //           const variantPictureURL = document.getElementById(`variant_picture_${pictureNumber}_${variantId}`).textContent.trim();
      //           imgElement.src = variantPictureURL;
      // });
      var selectedVariantId = variant.id;

        // Prüfe, ob die ausgewählte Variante die ID für sternenlicht hat
        if (selectedVariantId === 47297364033884) {
            // Zeige die Abschnitte für sternenlicht an und verstecke die Abschnitte für traumland
            document.querySelectorAll('.sternenlicht').forEach(function(section) {
                section.style.display = 'flex';
            });
            document.querySelectorAll('.traumland').forEach(function(section) {
                section.style.display = 'none';
            });
        } 
        // Prüfe, ob die ausgewählte Variante die ID für traumland hat
        else if (selectedVariantId === 47297364361564) {
            // Zeige die Abschnitte für traumland an und verstecke die Abschnitte für sternenlicht
            document.querySelectorAll('.traumland').forEach(function(section) {
                section.style.display = 'flex';
            });
            document.querySelectorAll('.sternenlicht').forEach(function(section) {
                section.style.display = 'none';
            });
        }
    }
  });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();